<template>
	<div class="fund-option" @click="selected">
		<div class="fund-option__content">
			<div class="fund-option__icon">
				<svg v-if="type === 'Fund with Cash' || type === 'Another wallet'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M21 18V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3H19C20.1 3 21 3.9 21 5V6H12C10.89 6 10 6.9 10 8V16C10 17.1 10.89 18 12 18H21ZM12 16H22V8H12V16ZM16 13.5C15.17 13.5 14.5 12.83 14.5 12C14.5 11.17 15.17 10.5 16 10.5C16.83 10.5 17.5 11.17 17.5 12C17.5 12.83 16.83 13.5 16 13.5Z" fill="currentColor"/>
				</svg>
				<svg v-if="type === 'Fund with Fintech Apps'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 19H7V5H17V19Z" fill="currentColor"/>
				</svg>
				<svg v-if="type === 'Fund with debit card' || type === 'Fund with bank transfer' || type === 'Bank or Card'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="currentColor"/>
				</svg>
				<svg v-if="type === 'P2P Transfers'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M16 11C17.66 0 2.99-1.34 2.99-3S17.66 5 16 5C14.34 5 13 6.34 13 8S14.34 11 16 11ZM8 11C9.66 11 10.99-1.34 10.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8S6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z" fill="currentColor"/>
				</svg>
				<svg v-if="type === 'Crypto'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12.88 17.76V19H11.12V17.71C9.47 17.4 8.18 16.36 8.03 14.81H9.82C9.96 15.6 10.64 16.18 12 16.18C13.53 16.18 14 15.45 14 14.96C14 14.31 13.53 13.79 11.85 13.36C9.95 12.87 8.44 12.03 8.44 10.32C8.44 8.86 9.61 7.78 11.12 7.44V6.18H12.88V7.46C14.44 7.83 15.4 8.95 15.48 10.32H13.69C13.62 9.51 13.1 8.86 12 8.86C10.97 8.86 10.23 9.37 10.23 10.27C10.23 11.04 10.85 11.48 12.36 11.9C14.14 12.4 15.79 13.17 15.79 14.92C15.78 16.47 14.53 17.44 12.88 17.76Z" fill="currentColor"/>
				</svg>
			</div>
			<div class="fund-option__info">
				<h3 class="fund-option__title">{{ type }}</h3>
				<p class="fund-option__description" v-if="type !== 'Another wallet'">
					Fee: 
					<span class="fund-option__fee" v-if="type === 'Fund with debit card'">
						{{ (fundPercent.NGN * 100).toFixed(1) }}% - {{ fundPercent.USD * 100 }}%
					</span>
					<span class="fund-option__fee" v-if="type === 'P2P Transfers'">1.5%</span>
					<span class="fund-option__fee" v-if="type === 'Fund with bank transfer'">
						{{ (fundPercent.NGN * 100).toFixed(1) }}% - {{ fundPercent.USD * 100 }}%
					</span>
					<span class="fund-option__fee" v-if="type === 'Bank or Card'">
						{{ (fundPercent.NGN * 100).toFixed(1) }}% - {{ fundPercent.USD * 100 }}%
					</span>
					<span class="fund-option__fee" v-if="type === 'Fund with Fintech Apps'">
						{{ fundPercent.THEPEER * 100 }}%
					</span>
					<span class="fund-option__fee" v-if="type === 'Crypto'">
						{{ fundPercent.FLUIDCOINS * 100 }}%
					</span>
					<span v-if="currency === 'NGN'" class="fund-option__cap">• Capped at ₦2000</span>
				</p>
				<p class="fund-option__description" v-else>Currency Conversion</p>
				<div class="fund-option__provider" v-if="type === 'Crypto'">
					<span>Powered by Blockradar</span>
				</div>
				<div class="fund-option__provider" v-if="type === 'P2P Transfers'">
					<span>Powered by Accrue</span>
				</div>
				<div class="fund-option__provider" v-if="type === 'Another wallet' || (type === 'Fund with bank transfer' && currency === 'USD')">
					<span>Powered by GetEquity</span>
				</div>
				<div class="fund-option__provider" v-if="type === 'Fund with debit card'">
					<span>Powered by {{ capitalize(provider) }}</span>
				</div>
			</div>
		</div>
		<div class="fund-option__time">
			<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M7 0.333336C3.32 0.333336 0.333336 3.32 0.333336 7C0.333336 10.68 3.32 13.6667 7 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7C13.6667 3.32 10.68 0.333336 7 0.333336ZM7 12.3333C4.06 12.3333 1.66667 9.94 1.66667 7C1.66667 4.06 4.06 1.66667 7 1.66667C9.94 1.66667 12.3333 4.06 12.3333 7C12.3333 9.94 9.94 12.3333 7 12.3333ZM7.33334 3.66667H6.33334V7.66667L9.83334 9.76667L10.3333 8.94667L7.33334 7.16667V3.66667Z" fill="currentColor"/>
			</svg>
			<span v-if="type === 'Pay with Crypto' || type === 'USD Debit/Credit Card'">1 business day</span>
			<span v-else-if="type === 'Another wallet'">1 min</span>
			<span v-else>15 mins</span>
		</div>
	</div>
</template>

<script setup>
import { capitalize } from "@/utils/helpers";
import fundPercent from "@/utils/js/fundPercent.js";
import { computed, inject } from "vue";
import { useStore } from "vuex";

const store = useStore();

const emits = defineEmits(["clicked"]);
const props = defineProps({
	type: {
		type: String,
		required: true,
	},
});
const type = computed(() => props.type);
const currency = computed(() => store.getters["organisationModule/currency"]);
const provider = inject("provider");
const selected = () => {
	emits("clicked", type.value);
};
</script>

<style lang="scss" scoped>
.fund-option {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 20px;
	background: white;
	border: 1px solid #E2E8F0;
	border-radius: 10px;
	cursor: pointer;
	transition: all 0.15s ease;
	margin-bottom: 12px;

	&:hover {
		border-color: #4D84FF;
		background: #F8FAFC;
	}

	&__content {
		display: flex;
		align-items: flex-start;
		gap: 16px;
	}

	&__icon {
		width: 44px;
		height: 44px;
		border-radius: 10px;
		background: linear-gradient(135deg, #4D84FF 0%, #6B9AFF 100%);
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		flex-shrink: 0;
	}

	&__info {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	&__title {
		font-family: 'DM Sans', sans-serif;
		font-size: 15px;
		font-weight: 500;
		color: #0F172A;
		margin: 0;
	}

	&__description {
		font-family: 'DM Sans', sans-serif;
		font-size: 13px;
		font-weight: 400;
		color: #64748B;
		margin: 0;
	}

	&__fee {
		color: #4D84FF;
		font-weight: 500;
	}

	&__cap {
		color: #64748B;
		margin-left: 4px;
	}

	&__provider {
		font-family: 'DM Sans', sans-serif;
		font-size: 12px;
		font-weight: 400;
		color: #94A3B8;
		margin-top: 2px;
	}

	&__time {
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 6px 12px;
		background: #F1F5F9;
		border-radius: 20px;
		font-family: 'DM Sans', sans-serif;
		font-size: 12px;
		font-weight: 400;
		color: #64748B;
		flex-shrink: 0;

		svg {
			flex-shrink: 0;
		}
	}
}
</style>
